import {
  GroupLocator,
  TeamsMeetingLinkLocator,
} from "@azure/communication-calling";

export const navigateToHomePage = (): void => {
  console.log(window.location.href.split("?")[0]);
  window.location.href = window.location.href.split("?")[0];
};

export const getGroupIdFromUrl = (): GroupLocator | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const gid = urlParams.get("groupId");
  return gid ? { groupId: gid } : undefined;
};

export const getTeamsLinkFromUrl = (): TeamsMeetingLinkLocator | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const teamsLink = urlParams.get("teamsLink");
  return teamsLink ? { meetingLink: teamsLink } : undefined;
};

export const getFormattedDate = (orgDate: string): string => {
  let nDate = new Date(orgDate);
  let date: string = "";
  let d = nDate.getDate();
  let m = nDate.getMonth() + 1;
  let dd = d.toString();
  let mm = m.toString();
  var yyyy = nDate.getFullYear();

  if (d < 10) {
    dd = "0" + dd;
  }
  if (m < 10) {
    mm = "0" + mm;
  }

  date = `${dd}/${mm}/${yyyy}`;
  return date;
};

export const getDateFormatted = (orgDate?: Date): string => {
  let nDate = orgDate!;
  let date: string = "";
  let d = nDate.getDate();
  let m = nDate.getMonth() + 1;
  let dd = d.toString();
  let mm = m.toString();
  var yyyy = nDate.getFullYear();

  if (d < 10) {
    dd = "0" + dd;
  }
  if (m < 10) {
    mm = "0" + mm;
  }

  date = `${dd}/${mm}/${yyyy}`;
  return date;
};
